import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { config } from '../../common/';
import * as Events from '../../events';

const BaseLayout: React.FC<{}> = () => (
    <Route
        render={() => {
            return (
                <React.Fragment>
                    <Switch>
                        <Route exact path={[`${config.BaseURL}/events`, `${config.AlternativeBaseURL}/events`]} component={Events.EventsLayout} />
                    </Switch>
                </React.Fragment>
            );
        }}
    />);

export default BaseLayout;
